import { mapState, mapActions } from 'vuex';
import notificationService from '@motionelements/core/src/services/notification.service.js';
import { downloadElement } from '@motionelements/core/src/services/download.service.js';
import { isFileBasedProduct } from '@motionelements/product2025/src/helpers/productMap.js';
import productPageEventsMixin from '@motionelements/catalog/src/modules/product/mixins/product-page-events.mixin.js';
import showSignUpModalMixin from '@motionelements/product2025/src/mixins/show-sign-up-modal.mixin.js';

export default {
  mixins: [showSignUpModalMixin, productPageEventsMixin],
  computed: {
    ...mapState({
      cartItems: state => state.cart.navItems,
    }),
    isAdded() {
      return (productId) => this.cartItems.map(({ id }) => id).includes(productId);
    },
  },
  methods: {
    ...mapActions({
      ADD_ELEMENTS_TO_CART: 'cart/ADD_ELEMENTS_TO_CART',
    }),
    addProductToCart(skus) {
      return this.loggedInCheck()
        .then((loggedIn) => {
          if (loggedIn) {
            return this.ADD_ELEMENTS_TO_CART({ skus })
              .then((response) => {
                console.log('added to cart', response);
                if (response.status === 201) {
                  notificationService.alert({
                    level: 'success',
                    title: this.$i18n.t('favorites.product_added_to_your_cart'),
                  });
                  this.$bus.$emit('product-added-to-cart', {
                    products: response.data.data,
                  });
                }
              })
              .catch((err) => {
                console.error(err);
                throw new Error(err);
              });
          }
        });
    },
    downloadProduct(variantId, downloadMethod, product) {
      return downloadElement({
        method: downloadMethod,
        sku: variantId,
      })
        .then((response) => {
          console.log(response);
          const { status, data: { data: { download, order } } } = response;
          if ([200, 201].includes(status)) {
            if (response.status === 201) {
              this.emitProductEvent('product-licensed', {
                product,
                order,
                timestamp: _.get(order, 'purchasedAt') || null,
              });
            }
            if (!isFileBasedProduct(product)) {
              this.showDownloadNonFileProductModal({ product, ...download });
            } else if (product) {
              product.downloadable = true;
              const downloadFileUrl = _.get(download, 'file.url');
              if (downloadFileUrl) {
                this.emitProductEvent('product-downloaded', {
                  product,
                  order,
                  timestamp: _.get(download, 'createdAt') || null,
                });
                window.location.href = downloadFileUrl;
              }
            }
          }
        })
        .catch(err => {
          console.error(err);
          throw new Error(err);
        });
    },
  },
};
